import { useEffect } from "react";

/**
 * Dynamically updates the web app manifest's start_url to the current page URL.
 * This ensures that mobile "Add to Home Screen" saves a link to the current page
 * instead of the root URL defined in the static manifest.json.
 *
 * On unmount, restores the original manifest.json reference.
 */
export const useDynamicManifest = () => {
  useEffect(() => {
    const manifestEl = document.querySelector<HTMLLinkElement>(
      'link[rel="manifest"]',
    );
    if (!manifestEl) return;

    const originalHref = manifestEl.getAttribute("href");

    const manifest = {
      short_name: "IBAN oplata",
      name: "IBAN oplata",
      icons: [
        {
          src: "favicon.ico",
          sizes: "64x64 32x32 24x24 16x16",
          type: "image/x-icon",
        },
      ],
      start_url: window.location.href,
      display: "standalone",
      theme_color: "#000000",
      background_color: "#ffffff",
    };

    manifestEl.setAttribute(
      "href",
      "data:application/json," + encodeURIComponent(JSON.stringify(manifest)),
    );

    return () => {
      if (originalHref) {
        manifestEl.setAttribute("href", originalHref);
      }
    };
  }, []);
};
